import { render, staticRenderFns } from "./CustomQuestionTable.vue?vue&type=template&id=1ac77cbc&scoped=true&"
import script from "./CustomQuestionTable.vue?vue&type=script&lang=js&"
export * from "./CustomQuestionTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomQuestionTable.vue?vue&type=style&index=0&id=1ac77cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac77cbc",
  null
  
)

export default component.exports